/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { WoundAssessmentDataViewModel } from './WoundAssessmentDataViewModel'; 

export function getWoundAssessmentDataOptions(woundAssessmentId: string, onSuccess?: (result: WoundAssessmentDataViewModel) => void) {
	return queryOptions({
		queryKey: ['wound-assessment-data', woundAssessmentId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/woundmanagement/queries/getwoundassessmentdata/' + woundAssessmentId;
			const resp = await axios.get<WoundAssessmentDataViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(woundAssessmentId)
	});
}